import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './styles/globals.css'
import './styles/theme-effects.css'
import './styles/theme-backgrounds.css'
import { isPublicRoute, usesPublicPlatformTheme } from '@/utils/route.util'
import {
  applyDefaultThemeTokens,
  applyShellDesignTokens,
  resetDocumentAppearanceToDefaults,
} from '@/utils/theme-application.util'
import { applyDocumentFavicon } from '@/config/branding.config'

applyShellDesignTokens()
applyDocumentFavicon()

if (typeof window !== 'undefined' && isPublicRoute(window.location.pathname)) {
  if (usesPublicPlatformTheme(window.location.pathname)) {
    document.documentElement.classList.remove('dark')
    applyDefaultThemeTokens('light')
  } else {
    resetDocumentAppearanceToDefaults()
  }
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)

